import { PaginationProps } from 'antd';
import { TrialView } from '@data/sdk/match';
import { AntdPagination } from '@ui/components';
import { Trial } from './components';

type TrialListProps = {
  paginationParams: PaginationProps;
  trials: TrialView[];
};

export const TrialsList = ({ trials, paginationParams }: TrialListProps) => {
  return (
    <>
      <ul className="list-none m-0 px-4">
        {trials.map((trial) => (
          <Trial key={trial.id} trial={trial} />
        ))}
      </ul>
      {(paginationParams.total || 0) > (paginationParams.pageSize || 0) && (
        <AntdPagination className="mt-4" {...paginationParams} />
      )}
    </>
  );
};
